/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState } from 'react'

import Menu from '../../../components/Menu'

import { ToastContainer } from 'react-toastify'
import { useForm } from "react-hook-form"

import { post } from '../../../services/http'
import { notify } from '../../../components/Toast'

import { useNavigate } from 'react-router-dom'

function index() {
  const navigate = useNavigate()
  const [clickButton, setClickButton] = useState(false)
  const [sliderCount, setsliderCount] = useState(2)
  const [sliders, setSliders] = useState([{ id : 1 }])

  document.title = 'ایجاد اسلایدر'

  const timeHandler = () => {
    setsliderCount(sliderCount + 1)
    setSliders(oldArray => [...oldArray, { id : sliderCount}])
  }

  const { register, handleSubmit } = useForm()

  const token = localStorage.getItem('token')

  const onSubmit = (data, e) => {
    e.preventDefault()
    setClickButton(true)

    let count = 1
    const sliderArray = []
    while(count < sliderCount) {
      const item =  {
        sliderLink: data['sliderLink' + count],
        sliderPicture: data['sliderPicture' + count]
      }
      sliderArray.push(item)
      count++
    }

    post(`/api/admin/sliders?token=${token}`, { title: data.title, slider: sliderArray }).then(response => {
        notify('success', response.data.messageFa)
        setTimeout(() => {
          navigate('/sliders')
        }, 2000)
      }).catch(error => {
        setClickButton(false)
        if (error) {
          notify('error', error)
        }
        notify('error', 'خطا در ارسال اطلاعات')
      })
  }

  return (
    <main id='panel'>
      <ToastContainer rtl />
      <Menu page={'slider'} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='panelBody'>
        <section className='panelContent'>
          <div className='title'>
            <div className='right'>
              <div className='text'>
                ایجاد اسلایدر
              </div>
            </div>

            <div className='left'>
            </div>
          </div>

          <form className='form' onSubmit={handleSubmit(onSubmit)}>
            <div className='title'>
              * برای ایجاد اسلایدر جدید لطفا تمامی فیلد های مشخص شده را پر کنید.
            </div>
            <div className='lineTitle'>
              <hr />
              اطلاعات اسلایدر
              <hr />
            </div>
            <div className='row'>
              <div className='column'>
                <label htmlFor='resturantDetails'>نام اسلایدر * :</label>
                <input id='resturantDetails' {...register("title", { required: true, minLength: 3 })} type='text' placeholder='محصولات ...' />
                <small id='resturantDetailsAlert'>توضیحات باید وارد شود</small>
              </div>
            </div>
            {sliders.map((item, index) => (
              <div className='row' key={index} id={item.id}>
                <div className='column'>
                  <label htmlFor='resturantDay'>لینک * :</label>
                  <input id='resturantDay' {...register(`sliderLink${item.id}`, { required: true, minLength: 3 })} type='text' placeholder='لینک' />
                  <small id='resturantDayAlert'>ویژگی باید وارد شود</small>
                </div>
                <div className='column'>
                  <label htmlFor='resturantTime'>لینک تصویر * :</label>
                  <input id='resturantTime' {...register(`sliderPicture${item.id}`, { required: true, minLength: 3 })} type='text' placeholder='لینک تصویر' />
                  <small id='resturantTimeAlert'>انگلیسی ویژگی باید وارد شود</small>
                </div>
              </div>
            ))}
            <div className="row">
              <div className="add" onClick={timeHandler}>
                +
              </div>
            </div>
            <button className='createButton' type='submit' style={clickButton ? { backgroundColor: 'gray' } : {}} disabled={clickButton ? true : false}>{clickButton ? 'در حال آپلود ...' : 'ایجاد اسلایدر'}</button>
          </form>
          <div className='copyright'>
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  )
}

export default index